export default __webpack_public_path__ + "30287965681562519adea25f988d2141.jpeg";